var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container info-cards"},[_c('div',{staticClass:"row grid-row-gap-20"},_vm._l((_vm.blocks),function(block,index){return _c('wave-text-block',{key:`wave-text-block_${_vm.uid}-${index}`,staticClass:"col-sm-6 col-12",attrs:{"is_green":Boolean(_vm.blocks % 2 ? !index : index),"title":block.title,"content":block.content}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }